import {getToken} from "./Common";

export function isLoggedIn() {
    return !!sessionStorage.getItem('roles')
}

export function hasAccessReport(mylink) {
    let x = {'link': mylink};
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/hasaccess`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        },
        body: JSON.stringify(x)
    })
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

export function isAdmin() {
    //let tmp = sessionStorage.getItem('roles');
    //return (tmp === null) ? false : ((tmp.indexOf('Admin') !== -1) && (tmp[(tmp.indexOf('Admin'))-1] !== '-'))
    // let tmp = sessionStorage.getItem('roles');
    // if (tmp){
    //         tmp = Object.keys(tmp).map(key => tmp[key])
    // }
    // return (tmp === null) ? false : tmp.indexOf('Admin') !== -1

    let tmp = sessionStorage.getItem('roles');
    return (((tmp === null) ? false : ((tmp.indexOf('Handwai-Org-Admin') !== -1)
            && (tmp[(tmp.indexOf('Handwai-Org-Admin')) - 1] !== '-')))
        || ((tmp === null) ? false : ((tmp.indexOf('Org-Admin') !== -1)
            && (tmp[(tmp.indexOf('Org-Admin')) - 1] !== '-'))))
}


export function isSuperAdmin() {
    // let tmp = sessionStorage.getItem('roles');
    // return (tmp === null) ? false : tmp.indexOf('Super-Admin') !== -1
    // let tmp = sessionStorage.getItem('roles');
    // if (tmp){
    //         tmp = Object.keys(tmp).map(key => tmp[key])
    //
    // }
    // return (tmp === null) ? false : tmp.indexOf('Super-Admin') !== -1
    let tmp = sessionStorage.getItem('roles');
    return (tmp === null) ? false : tmp.includes('Handwai-Super-Admin')!==false
}

export function isLVactive(){
        let tmp = sessionStorage.getItem('lv');
        return (tmp === "true")
}
export function isAPPactive(){
        let tmp = sessionStorage.getItem('app');
        return (tmp === "true")

}


export function isAnalyst() {
    let tmp = sessionStorage.getItem('roles');
    return (tmp === null) ? false : tmp.indexOf('Handwai-LV-Analyst') !== -1
}

export function isHandwaiPerson() {

    let roles = sessionStorage.getItem('roles');

    roles = JSON.parse(roles)
    //return roles.some(item=>item.indexOf("Handwai")>-1)
    return roles.findIndex(element => element.includes("Handwai"))!==-1
}


export function isCalculator() {
    // let tmp = sessionStorage.getItem('roles');
    // return (tmp === null) ? false : tmp.indexOf('Calculator') !== -1
    // let tmp = sessionStorage.getItem('roles');
    // if (tmp){
    //         tmp = Object.keys(tmp).map(key => tmp[key])
    // }
    // return (tmp === null) ? false : tmp.indexOf('Calculator') !== -1

    let tmp = sessionStorage.getItem('roles');
    return (tmp === null) ? false : tmp.indexOf('LV-Kalkulator') !== -1
}

export function isPL() {
    let tmp = sessionStorage.getItem('roles');
    return (tmp === null) ? false : tmp.indexOf('Bauablauf-PL') !== -1
}

export function isUploader() {
    let tmp = sessionStorage.getItem('roles');
    return (tmp === null) ? false : tmp.indexOf('LV-Uploader') !== -1
}

export function isAssistenz() {
    let tmp = sessionStorage.getItem('roles');
    return (tmp === null) ? false : tmp.indexOf('Bauablauf-Assistenz') !== -1
}

export function isMonteur() {
    let tmp = sessionStorage.getItem('roles');
    return (tmp === null) ? false : tmp.indexOf('Bauablauf-Monteur') !== -1
}

export function isHandwaiPL() {
    let tmp = sessionStorage.getItem('roles');
    return (tmp === null) ? false : tmp.indexOf('Handwai-PL') !== -1
}

export function isHandwaiAssistenz() {
    let tmp = sessionStorage.getItem('roles');
    return (tmp === null) ? false : tmp.indexOf('Handwai-Assistenz') !== -1
}

export function isHandwaiMonteur() {
    let tmp = sessionStorage.getItem('roles');
    return (tmp === null) ? false : tmp.indexOf('Handwai-Monteur') !== -1
}

export function isMobileAppUser() {
    // let tmp = sessionStorage.getItem('roles');
    // alert("kkk",(tmp === null) ? false : tmp.indexOf('Mobile-Pl') !== -1)
    // return (tmp === null) ? false : tmp.indexOf('Mobile-Pl') !== -1
    //  let tmp = sessionStorage.getItem('roles');
    // if (tmp){
    //          tmp = Object.keys(tmp).map(key => tmp[key])
    //  }
    //  return (tmp === null) ? false : tmp.indexOf('Mobile-Pl') !== -1
    let tmp = sessionStorage.getItem('roles');
    return (tmp === null) ? false : tmp.indexOf('Mobile-Pl') !== -1
}